export const button = {
  width: 120,
  height: 40,
  backgroundColor: '#232F78',
  color: '#fff',
  borderWidth: 0,
};
